import styled from "styled-components";
import { Typography, ShapeIcon } from "@flash-tecnologia/hros-web-ui-v2";

// TODO: Adjust DS colors
const colors = {
  info: {
    40: "#0F81BD",
    80: "#A0DAF8",
    90: "#D0ECFB",
    100: "#E7F6FD",
  },
};

// TODO: Adjust ShapeIcon icon size (padding)
export const InfoShapeIcon = styled(ShapeIcon)`
  flex-shrink: 0;
  cursor: pointer;
  padding: 4px;
  background-color: ${colors.info[80]};
  stroke: ${colors.info[40]};
  fill: ${colors.info[40]};
`;

// TODO: Custom line-height or should be adjusted on DS?
export const Title = styled(Typography)`
  line-height: 16px;
`;

// TODO: Implement Caption2 to DS
export const TypographyCaption2 = styled(Typography)`
  max-width: 145px;
  font-size: 10px;
  line-height: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Container = styled.div`
  max-width: 210px;
  height: 64px;
  display: flex;
  gap: ${({ theme }) => theme.spacings.xs4};
  padding: ${({ theme }) => theme.spacings.xs3};
  border-radius: ${({ theme }) => theme.borders.radius.s};
  align-items: center;
  cursor: pointer;
  background: ${colors.info[100]};
  border: 1px solid ${colors.info[90]};

  ${InfoShapeIcon} {
    background-color: ${colors.info[90]};
  }

  &:hover:not(:active) {
    background: ${colors.info[90]};

    ${InfoShapeIcon} {
      background-color: ${colors.info[80]};
    }
  }

  &:active {
    background: ${colors.info[100]};
    border: 1px solid ${colors.info[80]};

    ${InfoShapeIcon} {
      background-color: ${colors.info[90]};
    }

    ${Title}, ${TypographyCaption2} {
      color: ${colors.info[40]};
    }
  }
`;

export const Content = styled.div<{ isCollapsed?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings.xs5};
  transition: max-height 0.2s ease;
  ${({ isCollapsed }) =>
    isCollapsed &&
    `max-height: 0; padding-top: 0;
  `};
`;

export const CollapsedContainer = styled.div`
  width: 48px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.borders.radius.s};
  padding: ${({ theme }) => theme.spacings.xs5}
    ${({ theme }) => theme.spacings.xs3};
  background: ${colors.info[100]};
  border: 1px solid ${colors.info[90]};

  ${InfoShapeIcon} {
    background-color: ${colors.info[90]};
  }

  &:hover {
    background: ${colors.info[90]};

    ${InfoShapeIcon} {
      background-color: ${colors.info[80]};
    }
  }

  &:active {
    border: 1px solid ${colors.info[80]};

    ${InfoShapeIcon} {
      background-color: ${colors.info[90]};
    }
  }
`;
